import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=60b8d902&scoped=true&"
import script from "./StripePayment.vue?vue&type=script&lang=js&"
export * from "./StripePayment.vue?vue&type=script&lang=js&"
import style0 from "./StripePayment.vue?vue&type=style&index=0&id=60b8d902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b8d902",
  null
  
)

export default component.exports